import { useSearchParams } from "react-router-dom";
import SearchExperience from "@/components/SearchExperience";
import SEOHead from "@/components/SEOHead";

const titleCase = (slug) => (slug || "").split("--").pop().split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");

export default function Search() {
  const [sp] = useSearchParams();
  const state = sp.get("state") || "";
  const city = sp.get("city") || "";
  const course = sp.get("course") || "";
  const q = sp.get("q") || "";

  const locked = {};
  if (state) locked.state = state;
  if (city) locked.city = city;
  if (course) locked.course = course;

  const where = city ? titleCase(city) : (state ? titleCase(state) : "");
  const heading = course
    ? `${course} Colleges${where ? ` in ${where}` : ""}`
    : (where ? `Colleges in ${where}` : "Find Your College");
  const seoTitle = course
    ? `${course} Colleges${where ? ` in ${where}` : ""}`
    : (where ? `Colleges in ${where}` : "Find Colleges");

  return (
    <>
      <SEOHead
        title={seoTitle}
        description="Search and compare verified colleges across India by state, city, course and more — with free AI-powered admission guidance."
      />
      <SearchExperience
        key={`${state}|${city}|${course}|${q}`}
        lockedFilters={locked}
        initialQuery={q}
        title={heading}
        subtitle="Search across verified colleges in India — powered by our Master Intelligent Database."
      />
    </>
  );
}
